import { Checkbox as CheckboxOg } from "@chakra-ui/react"
import {
    useColors,
    type PropsWithChildrenAndStyle,
} from "@mallardbay/lib-react-components"
import React from "react"

interface Props extends PropsWithChildrenAndStyle {
    readonly isChecked: boolean
    readonly onChange: (value: boolean) => void
}

export function LargeGrayCheckbox({
    children,
    style,
    isChecked,
    onChange,
}: Props) {
    const colors = useColors()

    return (
        <CheckboxOg
            sx={style}
            isChecked={isChecked}
            onChange={(event) => onChange(event.target.checked)}
            size="lg"
            colorScheme="gray"
            borderColor={colors.text}
        >
            {children}
        </CheckboxOg>
    )
}
